import TypeIcon from './TypeIcon.jsx';

export default TypeIcon;
